import { Button, Modal, Select } from "antd";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import PersonasResult from "../Minified/Personas/PersonasResult";
import Container from "../General/Container/Container";
import { useRef } from "react";

export const pageSizesObj = {
    shortbondpaper: [215.9, 279.4],
    longbondpaper: [215.9, 330.2],
    a4bondpaper: [210, 297],
}
export const pageSizes = [{
    value: "a4bondpaper",
    label: "A4 Paper"
}, {
    value: "longbondpaper",
    label: "Long Bond Paper"
}, {
    value: "shortbondpaper",
    label: "Short Bond Paper"
}]

const PrintPage = ({
    sideMargin = 0,
    topMargin = 0,
    pageSize,
    children
}) => {
    const currentSize = pageSizesObj[pageSize]
    return <Container className="print-margin" style={{
        backgroundColor: "white", padding: `${topMargin}mm ${sideMargin}mm`, width: "fit-content"
    }}>
        <Container className="print-actualpage" style={{
            width: currentSize[0] + "mm",
            height: currentSize[1] + "mm"
        }}>
            {children}
        </Container>
    </Container>
}

export default PrintPage